import WatchedBillCategoryModel from './watched_bill_category_model';
export default Backbone.Collection.extend({
  model: WatchedBillCategoryModel
});